/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：45
 */

module.exports = {
  hide: "style_hide__29aBW",
  "coco-widget-wrapper": "style_coco-widget-wrapper__1HMMw",
  "coco-child-widget": "style_coco-child-widget__21iBc",
  "coco-child-widget-selected": "style_coco-child-widget-selected__1Ufm1",
  "coco-child-widget-full": "style_coco-child-widget-full__1Kd5A",
  flexSC: "style_flexSC__28Bvk",
  flexCC: "style_flexCC__wVKPU",
  flexLC: "style_flexLC__RHqAi",
  listViewerBox: "style_listViewerBox__3BFis",
  icon: "style_icon__HB3IA",
  itemTiled: "style_itemTiled__YZmyb",
  itemCard: "style_itemCard__1sNLY",
  templateSlot: "style_templateSlot__1vww2",
  template1: "style_template1__3RGv6",
  title: "style_title__TlUlN",
  titleSlot: "style_titleSlot__3mnTS",
  iconBox: "style_iconBox__2iYJD",
  template2: "style_template2__ZcKvY",
  subTitleBox: "style_subTitleBox__37sK1",
  subTitle: "style_subTitle__3Yfxl",
  subTitleSlot: "style_subTitleSlot__3zVVm",
  template3: "style_template3__3rg0p",
  smallImgBox: "style_smallImgBox__2jtsJ",
  smallImgSlot: "style_smallImgSlot__3eXgF",
  template4: "style_template4__1ttFZ",
  avatarAndTitle: "style_avatarAndTitle__4TTHA",
  avatarImgBox: "style_avatarImgBox__1zc2Y",
  avatarImgSlot: "style_avatarImgSlot__3ft2W",
  template5: "style_template5__tCCe9",
  imgAndTitleBox: "style_imgAndTitleBox__cEZ0v",
  desc: "style_desc__19QH7",
  titleSlot1: "style_titleSlot1__1VCSE",
  titleSlot2: "style_titleSlot2__CzFya",
  descSlot: "style_descSlot__3LeZD",
  template6: "style_template6__2W0XA",
  bannerImgBox: "style_bannerImgBox__nIUOv",
  bannerImgSlot: "style_bannerImgSlot__3tYT9",
  descSlot1: "style_descSlot1__Ww_C7",
  descSlot2: "style_descSlot2__3KkJt"
}
